import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShoppingBag, User, LogOut } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import { useQuoteCart } from '../context/QuoteCartContext';
import { useBuyer } from '../context/BuyerAuthContext';

export default function PublicHeader() {
  const { t } = useTranslation();
  const location = useLocation();
  const { items, setOpen } = useQuoteCart();
  const { buyer, logout } = useBuyer();
  const isHome = location.pathname === '/';

  const linkCls = (path) =>
    `font-sans text-sm uppercase tracking-[0.2em] link-underline transition-colors ${
      location.pathname === path ? 'text-[#C5A059]' : 'text-[#3D2817]/80 hover:text-[#3D2817]'
    }`;

  return (
    <header
      className={`sticky top-0 z-40 backdrop-blur-xl border-b border-[#E5D9C8] ${
        isHome ? 'bg-[#FBF8F3]/70' : 'bg-[#FBF8F3]/90'
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between gap-6">
        <Link to="/" data-testid="logo-link" className="font-serif text-xl md:text-2xl font-normal tracking-[0.15em] leading-none uppercase">
          COSMETISSAGE<sup className="text-[0.5em] ml-0.5 text-[#C5A059] font-sans">®</sup>
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          <Link data-testid="nav-catalog" to="/catalog" className={linkCls('/catalog')}>{t('nav.catalog')}</Link>
          <Link data-testid="nav-about" to="/about" className={linkCls('/about')}>{t('nav.about')}</Link>
        </nav>
        <div className="flex items-center gap-5">
          {buyer ? (
            <div className="hidden md:flex items-center gap-2 text-xs uppercase tracking-widest text-[#C5A059]">
              <User className="w-3.5 h-3.5" />
              <span>{buyer.company || buyer.name}</span>
              <button onClick={logout} data-testid="buyer-logout" className="ml-1 text-[#3D2817]/40 hover:text-[#3D2817]" title="Logout">
                <LogOut className="w-3.5 h-3.5" />
              </button>
            </div>
          ) : (
            <Link to="/buyer/login" data-testid="buyer-login-link" className="hidden md:flex items-center gap-2 text-xs uppercase tracking-widest text-[#3D2817]/60 hover:text-[#C5A059] transition-colors">
              <User className="w-3.5 h-3.5" /> Buyer
            </Link>
          )}
          <button
            data-testid="quote-cart-button"
            onClick={() => setOpen(true)}
            className="flex items-center gap-2 text-sm uppercase tracking-widest text-[#3D2817]/80 hover:text-[#C5A059] transition-colors"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="hidden sm:inline">{t('nav.quote')}</span>
            {items.length > 0 && (
              <span className="bg-[#C5A059] text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {items.length}
              </span>
            )}
          </button>
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
}
